import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=48fab543"
import script from "./CardContainer.vue?vue&type=script&lang=ts"
export * from "./CardContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fab543')) {
      api.createRecord('48fab543', component.options)
    } else {
      api.reload('48fab543', component.options)
    }
    module.hot.accept("./CardContainer.vue?vue&type=template&id=48fab543", function () {
      api.rerender('48fab543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/common/CardContainer.vue"
export default component.exports